import {
  ADMINS,
  COMPANY_ADMINS,
  SPRUCE_ADMINS,
  COMPANY_TESTERS,
  COMPANY_ROLES,
  DYNAMIC_LAYOUT_ADMINS,
} from '../constants/userRoles';
import {STANDARD_SUB} from '../constants/subscriptions';


export const hasGroupPermissions = (role='', groupRoles=[]) => {
  return groupRoles
    .map(groupRole => groupRole.toLowerCase())
    .includes(role.toLowerCase())
};

export const hasSetPermissions = (roles=[], groupRoles=[]) => {
  const rolesInLowerCase = roles.map(role => role.toLowerCase());
  const groupRolesInLowerCase = groupRoles.map(groupRole => groupRole.toLowerCase());

  return roles.length === groupRoles.length && groupRolesInLowerCase
    .every(groupRole => rolesInLowerCase.includes(groupRole));
};

export const isCompanyAdmin = (role='') => {
  return hasGroupPermissions(role, COMPANY_ADMINS);
};

export const isSpruceAdmin = (role='') => {
  return hasGroupPermissions(role, SPRUCE_ADMINS);
};

export const isAdmin = (role='') => {
  return hasGroupPermissions(role, ADMINS);
};

export const isTester = (role='') => {
  return hasGroupPermissions(role, COMPANY_TESTERS);
};

export const isCompanyUser = (role='') => {
  return hasGroupPermissions(role, COMPANY_ROLES);
};

export const isSubStandard = (role='', subscription) => {
  return !isSpruceAdmin(role) && (!subscription || subscription === STANDARD_SUB)
};

export const isDynamicLayoutAdmin = (roles = []) => {
  return hasSetPermissions(roles, DYNAMIC_LAYOUT_ADMINS);
};


// WEBPACK FOOTER //
// src/utils/roles.js